/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as DfAdminRouteRouteImport } from './routes/df-admin/route'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as DfAdminIndexRouteImport } from './routes/df-admin/index'
import { Route as DfAdminActivityRouteImport } from './routes/df-admin/activity'
import { Route as DfAdminAuditLogRouteImport } from './routes/df-admin/audit-log'
import { Route as DfAdminEvalsRouteImport } from './routes/df-admin/evals'
import { Route as DfAdminFeatureFlagsRouteImport } from './routes/df-admin/feature-flags'
import { Route as DfAdminIncidentsRouteImport } from './routes/df-admin/incidents'
import { Route as DfAdminModelsRouteImport } from './routes/df-admin/models'
import { Route as DfAdminOrganizationsRouteImport } from './routes/df-admin/organizations'
import { Route as DfAdminPlatformUsersRouteImport } from './routes/df-admin/platform-users'
import { Route as DfAdminQualityGuardRouteRouteImport } from './routes/df-admin/quality-guard/route'
import { Route as DfAdminSkillsRouteImport } from './routes/df-admin/skills'
import { Route as DfAdminUsageRouteImport } from './routes/df-admin/usage'
import { Route as DfAdminUsersRouteImport } from './routes/df-admin/users'
import { Route as ErrorNoOrganizationRouteImport } from './routes/error/no-organization'
import { Route as ProjectProjectIdRouteRouteImport } from './routes/project.$projectId/route'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsApiIntegrationsRouteImport } from './routes/settings/api-integrations'
import { Route as SettingsBillingRouteImport } from './routes/settings/billing'
import { Route as SettingsGeneralRouteImport } from './routes/settings/general'
import { Route as SettingsIntegrationsRouteImport } from './routes/settings/integrations'
import { Route as SettingsInviteLinksRouteImport } from './routes/settings/invite-links'
import { Route as SettingsMembersRolesRouteImport } from './routes/settings/members-roles'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as SettingsProfileRouteImport } from './routes/settings/profile'
import { Route as SettingsQualityGuardRouteImport } from './routes/settings/quality-guard'
import { Route as SettingsSecurityRouteImport } from './routes/settings/security'
import { Route as DfAdminOrganizationsOrgIdRouteImport } from './routes/df-admin/organizations.$orgId'
import { Route as DfAdminQualityGuardIndexRouteImport } from './routes/df-admin/quality-guard/index'
import { Route as DfAdminQualityGuardConfigurationRouteImport } from './routes/df-admin/quality-guard/configuration'
import { Route as DfAdminQualityGuardOperationalProfilesRouteImport } from './routes/df-admin/quality-guard/operational-profiles'
import { Route as DfAdminQualityGuardRulesRouteImport } from './routes/df-admin/quality-guard/rules'
import { Route as DfAdminQualityGuardRunsRouteImport } from './routes/df-admin/quality-guard/runs'
import { Route as DfAdminQualityGuardUsageRouteImport } from './routes/df-admin/quality-guard/usage'
import { Route as ProjectProjectIdIndexRouteImport } from './routes/project.$projectId/index'
import { Route as ProjectProjectIdSplatRouteImport } from './routes/project.$projectId/$'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const DfAdminRouteRoute = DfAdminRouteRouteImport.update({
  id: '/df-admin',
  path: '/df-admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const DfAdminIndexRoute = DfAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const DfAdminActivityRoute = DfAdminActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const DfAdminAuditLogRoute = DfAdminAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const DfAdminEvalsRoute = DfAdminEvalsRouteImport.update({
  id: '/evals',
  path: '/evals',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const DfAdminFeatureFlagsRoute = DfAdminFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const DfAdminIncidentsRoute = DfAdminIncidentsRouteImport.update({
  id: '/incidents',
  path: '/incidents',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const DfAdminModelsRoute = DfAdminModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const DfAdminOrganizationsRoute = DfAdminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const DfAdminPlatformUsersRoute = DfAdminPlatformUsersRouteImport.update({
  id: '/platform-users',
  path: '/platform-users',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const DfAdminQualityGuardRouteRoute =
  DfAdminQualityGuardRouteRouteImport.update({
    id: '/quality-guard',
    path: '/quality-guard',
    getParentRoute: () => DfAdminRouteRoute,
  } as any)
const DfAdminSkillsRoute = DfAdminSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const DfAdminUsageRoute = DfAdminUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const DfAdminUsersRoute = DfAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DfAdminRouteRoute,
} as any)
const ErrorNoOrganizationRoute = ErrorNoOrganizationRouteImport.update({
  id: '/no-organization',
  path: '/no-organization',
  getParentRoute: () => ErrorRoute,
} as any)
const ProjectProjectIdRouteRoute = ProjectProjectIdRouteRouteImport.update({
  id: '/project/$projectId',
  path: '/project/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsApiIntegrationsRoute = SettingsApiIntegrationsRouteImport.update({
  id: '/api-integrations',
  path: '/api-integrations',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsInviteLinksRoute = SettingsInviteLinksRouteImport.update({
  id: '/invite-links',
  path: '/invite-links',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsMembersRolesRoute = SettingsMembersRolesRouteImport.update({
  id: '/members-roles',
  path: '/members-roles',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsQualityGuardRoute = SettingsQualityGuardRouteImport.update({
  id: '/quality-guard',
  path: '/quality-guard',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsSecurityRoute = SettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const DfAdminOrganizationsOrgIdRoute =
  DfAdminOrganizationsOrgIdRouteImport.update({
    id: '/$orgId',
    path: '/$orgId',
    getParentRoute: () => DfAdminOrganizationsRoute,
  } as any)
const DfAdminQualityGuardIndexRoute =
  DfAdminQualityGuardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DfAdminQualityGuardRouteRoute,
  } as any)
const DfAdminQualityGuardConfigurationRoute =
  DfAdminQualityGuardConfigurationRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => DfAdminQualityGuardRouteRoute,
  } as any)
const DfAdminQualityGuardOperationalProfilesRoute =
  DfAdminQualityGuardOperationalProfilesRouteImport.update({
    id: '/operational-profiles',
    path: '/operational-profiles',
    getParentRoute: () => DfAdminQualityGuardRouteRoute,
  } as any)
const DfAdminQualityGuardRulesRoute =
  DfAdminQualityGuardRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => DfAdminQualityGuardRouteRoute,
  } as any)
const DfAdminQualityGuardRunsRoute = DfAdminQualityGuardRunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => DfAdminQualityGuardRouteRoute,
} as any)
const DfAdminQualityGuardUsageRoute =
  DfAdminQualityGuardUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => DfAdminQualityGuardRouteRoute,
  } as any)
const ProjectProjectIdIndexRoute = ProjectProjectIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectProjectIdRouteRoute,
} as any)
const ProjectProjectIdSplatRoute = ProjectProjectIdSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => ProjectProjectIdRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/df-admin': typeof DfAdminRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/error': typeof ErrorRouteWithChildren
  '/df-admin/quality-guard': typeof DfAdminQualityGuardRouteRouteWithChildren
  '/project/$projectId': typeof ProjectProjectIdRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/df-admin/activity': typeof DfAdminActivityRoute
  '/df-admin/audit-log': typeof DfAdminAuditLogRoute
  '/df-admin/evals': typeof DfAdminEvalsRoute
  '/df-admin/feature-flags': typeof DfAdminFeatureFlagsRoute
  '/df-admin/incidents': typeof DfAdminIncidentsRoute
  '/df-admin/models': typeof DfAdminModelsRoute
  '/df-admin/organizations': typeof DfAdminOrganizationsRouteWithChildren
  '/df-admin/platform-users': typeof DfAdminPlatformUsersRoute
  '/df-admin/skills': typeof DfAdminSkillsRoute
  '/df-admin/usage': typeof DfAdminUsageRoute
  '/df-admin/users': typeof DfAdminUsersRoute
  '/error/no-organization': typeof ErrorNoOrganizationRoute
  '/settings/api-integrations': typeof SettingsApiIntegrationsRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/invite-links': typeof SettingsInviteLinksRoute
  '/settings/members-roles': typeof SettingsMembersRolesRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/quality-guard': typeof SettingsQualityGuardRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/df-admin/': typeof DfAdminIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/df-admin/organizations/$orgId': typeof DfAdminOrganizationsOrgIdRoute
  '/df-admin/quality-guard/configuration': typeof DfAdminQualityGuardConfigurationRoute
  '/df-admin/quality-guard/operational-profiles': typeof DfAdminQualityGuardOperationalProfilesRoute
  '/df-admin/quality-guard/rules': typeof DfAdminQualityGuardRulesRoute
  '/df-admin/quality-guard/runs': typeof DfAdminQualityGuardRunsRoute
  '/df-admin/quality-guard/usage': typeof DfAdminQualityGuardUsageRoute
  '/project/$projectId/$': typeof ProjectProjectIdSplatRoute
  '/df-admin/quality-guard/': typeof DfAdminQualityGuardIndexRoute
  '/project/$projectId/': typeof ProjectProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/error': typeof ErrorRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/df-admin/activity': typeof DfAdminActivityRoute
  '/df-admin/audit-log': typeof DfAdminAuditLogRoute
  '/df-admin/evals': typeof DfAdminEvalsRoute
  '/df-admin/feature-flags': typeof DfAdminFeatureFlagsRoute
  '/df-admin/incidents': typeof DfAdminIncidentsRoute
  '/df-admin/models': typeof DfAdminModelsRoute
  '/df-admin/organizations': typeof DfAdminOrganizationsRouteWithChildren
  '/df-admin/platform-users': typeof DfAdminPlatformUsersRoute
  '/df-admin/skills': typeof DfAdminSkillsRoute
  '/df-admin/usage': typeof DfAdminUsageRoute
  '/df-admin/users': typeof DfAdminUsersRoute
  '/error/no-organization': typeof ErrorNoOrganizationRoute
  '/settings/api-integrations': typeof SettingsApiIntegrationsRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/invite-links': typeof SettingsInviteLinksRoute
  '/settings/members-roles': typeof SettingsMembersRolesRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/quality-guard': typeof SettingsQualityGuardRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/df-admin': typeof DfAdminIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/df-admin/organizations/$orgId': typeof DfAdminOrganizationsOrgIdRoute
  '/df-admin/quality-guard/configuration': typeof DfAdminQualityGuardConfigurationRoute
  '/df-admin/quality-guard/operational-profiles': typeof DfAdminQualityGuardOperationalProfilesRoute
  '/df-admin/quality-guard/rules': typeof DfAdminQualityGuardRulesRoute
  '/df-admin/quality-guard/runs': typeof DfAdminQualityGuardRunsRoute
  '/df-admin/quality-guard/usage': typeof DfAdminQualityGuardUsageRoute
  '/project/$projectId/$': typeof ProjectProjectIdSplatRoute
  '/df-admin/quality-guard': typeof DfAdminQualityGuardIndexRoute
  '/project/$projectId': typeof ProjectProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/df-admin': typeof DfAdminRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/error': typeof ErrorRouteWithChildren
  '/df-admin/quality-guard': typeof DfAdminQualityGuardRouteRouteWithChildren
  '/project/$projectId': typeof ProjectProjectIdRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/df-admin/activity': typeof DfAdminActivityRoute
  '/df-admin/audit-log': typeof DfAdminAuditLogRoute
  '/df-admin/evals': typeof DfAdminEvalsRoute
  '/df-admin/feature-flags': typeof DfAdminFeatureFlagsRoute
  '/df-admin/incidents': typeof DfAdminIncidentsRoute
  '/df-admin/models': typeof DfAdminModelsRoute
  '/df-admin/organizations': typeof DfAdminOrganizationsRouteWithChildren
  '/df-admin/platform-users': typeof DfAdminPlatformUsersRoute
  '/df-admin/skills': typeof DfAdminSkillsRoute
  '/df-admin/usage': typeof DfAdminUsageRoute
  '/df-admin/users': typeof DfAdminUsersRoute
  '/error/no-organization': typeof ErrorNoOrganizationRoute
  '/settings/api-integrations': typeof SettingsApiIntegrationsRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/invite-links': typeof SettingsInviteLinksRoute
  '/settings/members-roles': typeof SettingsMembersRolesRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/quality-guard': typeof SettingsQualityGuardRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/df-admin/': typeof DfAdminIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/df-admin/organizations/$orgId': typeof DfAdminOrganizationsOrgIdRoute
  '/df-admin/quality-guard/configuration': typeof DfAdminQualityGuardConfigurationRoute
  '/df-admin/quality-guard/operational-profiles': typeof DfAdminQualityGuardOperationalProfilesRoute
  '/df-admin/quality-guard/rules': typeof DfAdminQualityGuardRulesRoute
  '/df-admin/quality-guard/runs': typeof DfAdminQualityGuardRunsRoute
  '/df-admin/quality-guard/usage': typeof DfAdminQualityGuardUsageRoute
  '/project/$projectId/$': typeof ProjectProjectIdSplatRoute
  '/df-admin/quality-guard/': typeof DfAdminQualityGuardIndexRoute
  '/project/$projectId/': typeof ProjectProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/df-admin'
    | '/settings'
    | '/auth'
    | '/error'
    | '/df-admin/quality-guard'
    | '/project/$projectId'
    | '/auth/callback'
    | '/auth/login'
    | '/df-admin/activity'
    | '/df-admin/audit-log'
    | '/df-admin/evals'
    | '/df-admin/feature-flags'
    | '/df-admin/incidents'
    | '/df-admin/models'
    | '/df-admin/organizations'
    | '/df-admin/platform-users'
    | '/df-admin/skills'
    | '/df-admin/usage'
    | '/df-admin/users'
    | '/error/no-organization'
    | '/settings/api-integrations'
    | '/settings/billing'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/invite-links'
    | '/settings/members-roles'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/quality-guard'
    | '/settings/security'
    | '/df-admin/'
    | '/settings/'
    | '/df-admin/organizations/$orgId'
    | '/df-admin/quality-guard/configuration'
    | '/df-admin/quality-guard/operational-profiles'
    | '/df-admin/quality-guard/rules'
    | '/df-admin/quality-guard/runs'
    | '/df-admin/quality-guard/usage'
    | '/project/$projectId/$'
    | '/df-admin/quality-guard/'
    | '/project/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/error'
    | '/auth/callback'
    | '/auth/login'
    | '/df-admin/activity'
    | '/df-admin/audit-log'
    | '/df-admin/evals'
    | '/df-admin/feature-flags'
    | '/df-admin/incidents'
    | '/df-admin/models'
    | '/df-admin/organizations'
    | '/df-admin/platform-users'
    | '/df-admin/skills'
    | '/df-admin/usage'
    | '/df-admin/users'
    | '/error/no-organization'
    | '/settings/api-integrations'
    | '/settings/billing'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/invite-links'
    | '/settings/members-roles'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/quality-guard'
    | '/settings/security'
    | '/df-admin'
    | '/settings'
    | '/df-admin/organizations/$orgId'
    | '/df-admin/quality-guard/configuration'
    | '/df-admin/quality-guard/operational-profiles'
    | '/df-admin/quality-guard/rules'
    | '/df-admin/quality-guard/runs'
    | '/df-admin/quality-guard/usage'
    | '/project/$projectId/$'
    | '/df-admin/quality-guard'
    | '/project/$projectId'
  id:
    | '__root__'
    | '/'
    | '/df-admin'
    | '/settings'
    | '/auth'
    | '/error'
    | '/df-admin/quality-guard'
    | '/project/$projectId'
    | '/auth/callback'
    | '/auth/login'
    | '/df-admin/activity'
    | '/df-admin/audit-log'
    | '/df-admin/evals'
    | '/df-admin/feature-flags'
    | '/df-admin/incidents'
    | '/df-admin/models'
    | '/df-admin/organizations'
    | '/df-admin/platform-users'
    | '/df-admin/skills'
    | '/df-admin/usage'
    | '/df-admin/users'
    | '/error/no-organization'
    | '/settings/api-integrations'
    | '/settings/billing'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/invite-links'
    | '/settings/members-roles'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/quality-guard'
    | '/settings/security'
    | '/df-admin/'
    | '/settings/'
    | '/df-admin/organizations/$orgId'
    | '/df-admin/quality-guard/configuration'
    | '/df-admin/quality-guard/operational-profiles'
    | '/df-admin/quality-guard/rules'
    | '/df-admin/quality-guard/runs'
    | '/df-admin/quality-guard/usage'
    | '/project/$projectId/$'
    | '/df-admin/quality-guard/'
    | '/project/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DfAdminRouteRoute: typeof DfAdminRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ErrorRoute: typeof ErrorRouteWithChildren
  ProjectProjectIdRouteRoute: typeof ProjectProjectIdRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/df-admin': {
      id: '/df-admin'
      path: '/df-admin'
      fullPath: '/df-admin'
      preLoaderRoute: typeof DfAdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/df-admin/': {
      id: '/df-admin/'
      path: '/'
      fullPath: '/df-admin/'
      preLoaderRoute: typeof DfAdminIndexRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/activity': {
      id: '/df-admin/activity'
      path: '/activity'
      fullPath: '/df-admin/activity'
      preLoaderRoute: typeof DfAdminActivityRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/audit-log': {
      id: '/df-admin/audit-log'
      path: '/audit-log'
      fullPath: '/df-admin/audit-log'
      preLoaderRoute: typeof DfAdminAuditLogRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/evals': {
      id: '/df-admin/evals'
      path: '/evals'
      fullPath: '/df-admin/evals'
      preLoaderRoute: typeof DfAdminEvalsRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/feature-flags': {
      id: '/df-admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/df-admin/feature-flags'
      preLoaderRoute: typeof DfAdminFeatureFlagsRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/incidents': {
      id: '/df-admin/incidents'
      path: '/incidents'
      fullPath: '/df-admin/incidents'
      preLoaderRoute: typeof DfAdminIncidentsRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/models': {
      id: '/df-admin/models'
      path: '/models'
      fullPath: '/df-admin/models'
      preLoaderRoute: typeof DfAdminModelsRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/organizations': {
      id: '/df-admin/organizations'
      path: '/organizations'
      fullPath: '/df-admin/organizations'
      preLoaderRoute: typeof DfAdminOrganizationsRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/platform-users': {
      id: '/df-admin/platform-users'
      path: '/platform-users'
      fullPath: '/df-admin/platform-users'
      preLoaderRoute: typeof DfAdminPlatformUsersRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/quality-guard': {
      id: '/df-admin/quality-guard'
      path: '/quality-guard'
      fullPath: '/df-admin/quality-guard'
      preLoaderRoute: typeof DfAdminQualityGuardRouteRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/skills': {
      id: '/df-admin/skills'
      path: '/skills'
      fullPath: '/df-admin/skills'
      preLoaderRoute: typeof DfAdminSkillsRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/usage': {
      id: '/df-admin/usage'
      path: '/usage'
      fullPath: '/df-admin/usage'
      preLoaderRoute: typeof DfAdminUsageRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/df-admin/users': {
      id: '/df-admin/users'
      path: '/users'
      fullPath: '/df-admin/users'
      preLoaderRoute: typeof DfAdminUsersRouteImport
      parentRoute: typeof DfAdminRouteRoute
    }
    '/error/no-organization': {
      id: '/error/no-organization'
      path: '/no-organization'
      fullPath: '/error/no-organization'
      preLoaderRoute: typeof ErrorNoOrganizationRouteImport
      parentRoute: typeof ErrorRoute
    }
    '/project/$projectId': {
      id: '/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof ProjectProjectIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/api-integrations': {
      id: '/settings/api-integrations'
      path: '/api-integrations'
      fullPath: '/settings/api-integrations'
      preLoaderRoute: typeof SettingsApiIntegrationsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/billing': {
      id: '/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/integrations': {
      id: '/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/invite-links': {
      id: '/settings/invite-links'
      path: '/invite-links'
      fullPath: '/settings/invite-links'
      preLoaderRoute: typeof SettingsInviteLinksRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/members-roles': {
      id: '/settings/members-roles'
      path: '/members-roles'
      fullPath: '/settings/members-roles'
      preLoaderRoute: typeof SettingsMembersRolesRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/quality-guard': {
      id: '/settings/quality-guard'
      path: '/quality-guard'
      fullPath: '/settings/quality-guard'
      preLoaderRoute: typeof SettingsQualityGuardRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/security': {
      id: '/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof SettingsSecurityRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/df-admin/organizations/$orgId': {
      id: '/df-admin/organizations/$orgId'
      path: '/$orgId'
      fullPath: '/df-admin/organizations/$orgId'
      preLoaderRoute: typeof DfAdminOrganizationsOrgIdRouteImport
      parentRoute: typeof DfAdminOrganizationsRoute
    }
    '/df-admin/quality-guard/': {
      id: '/df-admin/quality-guard/'
      path: '/'
      fullPath: '/df-admin/quality-guard/'
      preLoaderRoute: typeof DfAdminQualityGuardIndexRouteImport
      parentRoute: typeof DfAdminQualityGuardRouteRoute
    }
    '/df-admin/quality-guard/configuration': {
      id: '/df-admin/quality-guard/configuration'
      path: '/configuration'
      fullPath: '/df-admin/quality-guard/configuration'
      preLoaderRoute: typeof DfAdminQualityGuardConfigurationRouteImport
      parentRoute: typeof DfAdminQualityGuardRouteRoute
    }
    '/df-admin/quality-guard/operational-profiles': {
      id: '/df-admin/quality-guard/operational-profiles'
      path: '/operational-profiles'
      fullPath: '/df-admin/quality-guard/operational-profiles'
      preLoaderRoute: typeof DfAdminQualityGuardOperationalProfilesRouteImport
      parentRoute: typeof DfAdminQualityGuardRouteRoute
    }
    '/df-admin/quality-guard/rules': {
      id: '/df-admin/quality-guard/rules'
      path: '/rules'
      fullPath: '/df-admin/quality-guard/rules'
      preLoaderRoute: typeof DfAdminQualityGuardRulesRouteImport
      parentRoute: typeof DfAdminQualityGuardRouteRoute
    }
    '/df-admin/quality-guard/runs': {
      id: '/df-admin/quality-guard/runs'
      path: '/runs'
      fullPath: '/df-admin/quality-guard/runs'
      preLoaderRoute: typeof DfAdminQualityGuardRunsRouteImport
      parentRoute: typeof DfAdminQualityGuardRouteRoute
    }
    '/df-admin/quality-guard/usage': {
      id: '/df-admin/quality-guard/usage'
      path: '/usage'
      fullPath: '/df-admin/quality-guard/usage'
      preLoaderRoute: typeof DfAdminQualityGuardUsageRouteImport
      parentRoute: typeof DfAdminQualityGuardRouteRoute
    }
    '/project/$projectId/': {
      id: '/project/$projectId/'
      path: '/'
      fullPath: '/project/$projectId/'
      preLoaderRoute: typeof ProjectProjectIdIndexRouteImport
      parentRoute: typeof ProjectProjectIdRouteRoute
    }
    '/project/$projectId/$': {
      id: '/project/$projectId/$'
      path: '/$'
      fullPath: '/project/$projectId/$'
      preLoaderRoute: typeof ProjectProjectIdSplatRouteImport
      parentRoute: typeof ProjectProjectIdRouteRoute
    }
  }
}

interface DfAdminQualityGuardRouteRouteChildren {
  DfAdminQualityGuardConfigurationRoute: typeof DfAdminQualityGuardConfigurationRoute
  DfAdminQualityGuardOperationalProfilesRoute: typeof DfAdminQualityGuardOperationalProfilesRoute
  DfAdminQualityGuardRulesRoute: typeof DfAdminQualityGuardRulesRoute
  DfAdminQualityGuardRunsRoute: typeof DfAdminQualityGuardRunsRoute
  DfAdminQualityGuardUsageRoute: typeof DfAdminQualityGuardUsageRoute
  DfAdminQualityGuardIndexRoute: typeof DfAdminQualityGuardIndexRoute
}

const DfAdminQualityGuardRouteRouteChildren: DfAdminQualityGuardRouteRouteChildren =
  {
    DfAdminQualityGuardConfigurationRoute:
      DfAdminQualityGuardConfigurationRoute,
    DfAdminQualityGuardOperationalProfilesRoute:
      DfAdminQualityGuardOperationalProfilesRoute,
    DfAdminQualityGuardRulesRoute: DfAdminQualityGuardRulesRoute,
    DfAdminQualityGuardRunsRoute: DfAdminQualityGuardRunsRoute,
    DfAdminQualityGuardUsageRoute: DfAdminQualityGuardUsageRoute,
    DfAdminQualityGuardIndexRoute: DfAdminQualityGuardIndexRoute,
  }

const DfAdminQualityGuardRouteRouteWithChildren =
  DfAdminQualityGuardRouteRoute._addFileChildren(
    DfAdminQualityGuardRouteRouteChildren,
  )

interface DfAdminOrganizationsRouteChildren {
  DfAdminOrganizationsOrgIdRoute: typeof DfAdminOrganizationsOrgIdRoute
}

const DfAdminOrganizationsRouteChildren: DfAdminOrganizationsRouteChildren = {
  DfAdminOrganizationsOrgIdRoute: DfAdminOrganizationsOrgIdRoute,
}

const DfAdminOrganizationsRouteWithChildren =
  DfAdminOrganizationsRoute._addFileChildren(DfAdminOrganizationsRouteChildren)

interface DfAdminRouteRouteChildren {
  DfAdminQualityGuardRouteRoute: typeof DfAdminQualityGuardRouteRouteWithChildren
  DfAdminActivityRoute: typeof DfAdminActivityRoute
  DfAdminAuditLogRoute: typeof DfAdminAuditLogRoute
  DfAdminEvalsRoute: typeof DfAdminEvalsRoute
  DfAdminFeatureFlagsRoute: typeof DfAdminFeatureFlagsRoute
  DfAdminIncidentsRoute: typeof DfAdminIncidentsRoute
  DfAdminModelsRoute: typeof DfAdminModelsRoute
  DfAdminOrganizationsRoute: typeof DfAdminOrganizationsRouteWithChildren
  DfAdminPlatformUsersRoute: typeof DfAdminPlatformUsersRoute
  DfAdminSkillsRoute: typeof DfAdminSkillsRoute
  DfAdminUsageRoute: typeof DfAdminUsageRoute
  DfAdminUsersRoute: typeof DfAdminUsersRoute
  DfAdminIndexRoute: typeof DfAdminIndexRoute
}

const DfAdminRouteRouteChildren: DfAdminRouteRouteChildren = {
  DfAdminQualityGuardRouteRoute: DfAdminQualityGuardRouteRouteWithChildren,
  DfAdminActivityRoute: DfAdminActivityRoute,
  DfAdminAuditLogRoute: DfAdminAuditLogRoute,
  DfAdminEvalsRoute: DfAdminEvalsRoute,
  DfAdminFeatureFlagsRoute: DfAdminFeatureFlagsRoute,
  DfAdminIncidentsRoute: DfAdminIncidentsRoute,
  DfAdminModelsRoute: DfAdminModelsRoute,
  DfAdminOrganizationsRoute: DfAdminOrganizationsRouteWithChildren,
  DfAdminPlatformUsersRoute: DfAdminPlatformUsersRoute,
  DfAdminSkillsRoute: DfAdminSkillsRoute,
  DfAdminUsageRoute: DfAdminUsageRoute,
  DfAdminUsersRoute: DfAdminUsersRoute,
  DfAdminIndexRoute: DfAdminIndexRoute,
}

const DfAdminRouteRouteWithChildren = DfAdminRouteRoute._addFileChildren(
  DfAdminRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsApiIntegrationsRoute: typeof SettingsApiIntegrationsRoute
  SettingsBillingRoute: typeof SettingsBillingRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute
  SettingsInviteLinksRoute: typeof SettingsInviteLinksRoute
  SettingsMembersRolesRoute: typeof SettingsMembersRolesRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsQualityGuardRoute: typeof SettingsQualityGuardRoute
  SettingsSecurityRoute: typeof SettingsSecurityRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsApiIntegrationsRoute: SettingsApiIntegrationsRoute,
  SettingsBillingRoute: SettingsBillingRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SettingsInviteLinksRoute: SettingsInviteLinksRoute,
  SettingsMembersRolesRoute: SettingsMembersRolesRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsQualityGuardRoute: SettingsQualityGuardRoute,
  SettingsSecurityRoute: SettingsSecurityRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

interface AuthRouteChildren {
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute,
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface ErrorRouteChildren {
  ErrorNoOrganizationRoute: typeof ErrorNoOrganizationRoute
}

const ErrorRouteChildren: ErrorRouteChildren = {
  ErrorNoOrganizationRoute: ErrorNoOrganizationRoute,
}

const ErrorRouteWithChildren = ErrorRoute._addFileChildren(ErrorRouteChildren)

interface ProjectProjectIdRouteRouteChildren {
  ProjectProjectIdSplatRoute: typeof ProjectProjectIdSplatRoute
  ProjectProjectIdIndexRoute: typeof ProjectProjectIdIndexRoute
}

const ProjectProjectIdRouteRouteChildren: ProjectProjectIdRouteRouteChildren = {
  ProjectProjectIdSplatRoute: ProjectProjectIdSplatRoute,
  ProjectProjectIdIndexRoute: ProjectProjectIdIndexRoute,
}

const ProjectProjectIdRouteRouteWithChildren =
  ProjectProjectIdRouteRoute._addFileChildren(
    ProjectProjectIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DfAdminRouteRoute: DfAdminRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ErrorRoute: ErrorRouteWithChildren,
  ProjectProjectIdRouteRoute: ProjectProjectIdRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
